import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Loader from 'react-loader';
import { Container, Button } from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import { fetchServices } from '../modules/ServiceList/actions';
import { isLoaded, getError } from '../modules/ServiceList/reducer';
import ServiceList from '../modules/ServiceList';

class ServiceListpage extends Component {
  componentDidMount() {
    this.props.fetchServices();
  }

  render() {
    const { isLoaded } = this.props;
    return (
      <Layout>
        <Container>
          <PageNav>
            <h1>Služby</h1>
            <Button tag={Link} to="/sluzby/new" color="primary">
              Nová služba
            </Button>
          </PageNav>
          <Loader loaded={isLoaded}>
            <ServiceList />
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchServices }
)(ServiceListpage);



// WEBPACK FOOTER //
// ./src/pages/ServiceListPage.js